module.exports = __webpack_public_path__ + "img/6.03640ec5.png";